<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px">
        <el-row>
          <el-col :lg="5" :xl="5">
            <el-form-item label="申请单号" class="EL-Form-Item">
              <el-input
                v-model="examinpagination.samCode"
                placeholder="请输入"
                @change="saveSearch()"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="物料编号" class="EL-Form-Item">
              <el-input
                v-model="examinpagination.matCode"
                placeholder="请输入"
                @change="saveSearch()"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="4" :xl="4">
            <el-form-item class="btn-edit-delete EL-Form-Item">
              <el-button class="btn-t-edit" @click="saveSearch()">
                查询
              </el-button>
              <el-button class="btn-t-delete" @click="examinResetData()">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>
      <plabel text="待审批">
        <el-button
          class="btn-t-edit"
          v-authority="'BACK_MENU4_M10_B1'"
          @click="examineResultOK()"
          >审批通过</el-button
        >
        <el-button
          class="btn-t-edit"
          v-authority="'BACK_MENU4_M10_B2'"
          @click="examineNOK()"
          >审批不通过</el-button
        >
        <el-button
          v-authority="'BACK_MENU4_M10_B3'"
          :loading="downloadLoadingExamine"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFileExamine()"
          >导出EXCEL</el-button
        >
      </plabel>
      <!-- 展示 -->
      <h-table
        :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="getExamineAuxi()"
        :data="examineData"
        pagination
        :nowPage.sync="pageMap.pageNum"
        :pageSize.sync="pageMap.pageSize"
        :total.sync="pageMap.total"
        @selectionChange="selectExamineAuxi"
      >
        <el-table-column type="selection" align="center"> </el-table-column>
        <el-table-column label="申请单号" prop="samCode" align="center">
        </el-table-column>
        <el-table-column label="物料编码" prop="matCode" align="center">
        </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center">
        </el-table-column>
        <el-table-column label="需求数量" prop="matQuan" align="center">
        </el-table-column>
        <el-table-column label="申请人员" prop="person" align="center">
        </el-table-column>
        <el-table-column label="申请部门" prop="section" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.section }} - {{ scope.row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" align="center">
        </el-table-column>
        <el-table-column label="产品型号" prop="productModel" align="center">
        </el-table-column>
        <el-table-column label="工单数量" prop="orderQuantity" align="center">
        </el-table-column>
        <el-table-column label="寿命" prop="life" align="center">
        </el-table-column>
        <el-table-column label="工序" prop="ddName" align="center">
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == '10'">待审批</div>
            <div v-if="scope.row.status == '20'">审批完成</div>
            <div v-if="scope.row.status == '40'">拣配中</div>
            <div v-if="scope.row.status == '50'">拣配完成</div>
            <div v-if="scope.row.status == '60'">出库完成</div>
            <div v-if="scope.row.status == '70'">关闭</div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="createTime" palign="center">
        </el-table-column>
        <el-table-column label="需求时间" prop="requireDate" align="center">
        </el-table-column>
        <el-table-column label="审批部门" prop="examineType" align="center">
        </el-table-column>
        <el-table-column label="申请审批人员" prop="examineWaitPerson" align="center">
        </el-table-column>
      </h-table>
    </box>

    <!-- 直接出库 -->
    <el-dialog title="审批不通过" class="fromDialog" :style="$popups.popups(0.4, 0.2)" :visible.sync="returnExamineShow">
      <el-form label-width="140px">
        <el-form-item label="审批不通过原因：" class="EL-Form-Item">
					<el-input v-model="resultMessage" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button class="btn-t-info" @click="(resultMessage = ''), (returnExamineShow = false)" type="info" >取 消</el-button>
        <el-button class="btn-t-edit" @click="examineResultNOK()" type="danger">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 打印 -->
    <el-dialog
      title="打印"
      :visible.sync="printShow"
      width="1200px"
      :close-on-click-modal="false"
    >
      <div style="margin-top: 20px; margin-left: 900px; margin-bottom: 20px">
        <el-button
          class="btn-t-info"
          type="info"
          @click="(printShow = false), (printList = [])"
          >取消</el-button
        >
        <el-button
          class="btn-t-edit"
          @click="(print = true), (printShow = false)"
          >打印</el-button
        >
      </div>
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <th>SKF</th>
                  <th colspan="3" rowspan="3">
                    Special Withdraw Requisition <br /><span
                      >特殊领用申请单</span
                    >
                  </th>
                  <th rowspan="2" style="font-size: 12px">ForM No.</th>
                  <th colspan="2" style="font-size: 12px">
                    Quaity Document Ref
                  </th>
                </tr>
                <tr>
                  <th rowspan="2" style="font-size: 12px">SKF DaLian</th>
                  <th style="font-size: 12px">Doc.Name</th>
                  <th style="font-size: 12px">Section</th>
                </tr>
                <tr>
                  <th style="font-size: 12px">Revision No.</th>
                  <th style="font-size: 12px">Date（YY.MM）</th>
                  <th style="font-size: 12px">Pages</th>
                </tr>
              </table>
            </div>
          </div>
          <div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <td>Req.No<br />申请单号</td>
                  <td colspan="2"></td>
                  <td>Cost Ctr<br />成本中心</td>
                  <td></td>
                  <td>Date<br />日期</td>
                  <td>{{ timeDate }}</td>
                </tr>
                <tr>
                  <td colspan="2">Stock Code<br />库存编号</td>
                  <td>Quantity<br />数量</td>
                  <td colspan="3">Intiate Reason<br />申请原因</td>
                  <td>Remarks<br />备注</td>
                </tr>
                <tr v-for="(item, index) in printList" :key="index">
                  <td colspan="2">{{ item.matCode }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td colspan="3"></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td></td>
                  <td colspan="3"></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td></td>
                  <td colspan="3"></td>
                  <td></td>
                </tr>
                <tr>
                  <td rowspan="2">Request & Approval<br />申请/批准</td>
                  <td>Initiator<br />申请人</td>
                  <td>Depar. Mgr<br />部门经理</td>
                  <td>Planner<br />计划员</td>
                  <td>Controller<br />成本控制</td>
                  <td>WH Worker<br />库管员</td>
                  <td>WH Supervisor<br />通道主管</td>
                </tr>
                <tr>
                  <td>{{ person }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </v-print>
      <div class="print" style="margin-top: 50px; margin-bottom: 50px">
        <!-- <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vPrint from "syl-vue-printer";
import siblingCall from "@/libs/siblingCall";
import moment from "moment";
export default {
  name: "GetApplyExamine",
  components: {
    vPrint,
  },
  data() {
    return {
      auxiMaterialLoading: true,
      addAuxiMaterialData: [],
      //打印
      print: false,
      printShow: false,
      printList: [],
      timeDate: "",

      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      inQuan: 0,
      mtTypes: "",
      //主数据
      mainData: [],
      examinpagination: {
        samCode: "",
        matCode: "",
      },
      pageMap: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
      //新增框校验
      rules: {
        matCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        matQuan: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        section: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        examineWaitEmp: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        requireDate: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },

      fcCode: localStorage.getItem("fcCode") || "",
      person: localStorage.getItem("user") || "",
      personNumber: localStorage.getItem("empNumber") || null,
      whCode: localStorage.getItem("whCode") || "",
      //全选
      checkList: [],
      checkListExamine: [],

      downloadLoadingExamine: false,
      selectExamineAuxiList: [],

      //审批
      returnExamineShow: false,
      resultMessage: "",
      examineData: [],
      panduan: true,

      downloadLoading: false, //下载中
      MaterialDatas: false,

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,
    };
  },
  watch: {},
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.requireDate[0]) {
            return time.getTime() < new Date(_this.pagination.requireDate[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.requireDate[1]) {
            return time.getTime() > new Date(_this.pagination.requireDate[1]);
          }
        },
      };
    },
  },
  methods: {
    selectExamineAuxi(val) {
      this.selectExamineAuxiList = val;
    },
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getExamineAuxi();
      }, 1000);
    },

    //确认审批
    examineResultOK() {
      if (this.selectExamineAuxiList.length == 0) {
        this.$message({
          message: "请选择审批单！",
          type: "warning",
        });
        return;
      }

      this.$confirm("已选申请单是否全部审批通过?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/auxiMaterial/examineResult",
              method: "POST",
              showLoading: true,
              data: this.selectExamineAuxiList,
              params: {
                person: localStorage.getItem("user") || "",
                personNumber: localStorage.getItem("empNumber") || null,
                whCode: localStorage.getItem("whCode") || "",
                result: "10",
                resultMessage: "",
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getExamineAuxi();
                this.logRemarks = "auxiMaterial：领用申请审批通过操作成功";
              } else {
                this.$message({
                  message: resp.message,
                  type: "warning",
                });
                this.logRemarks = "auxiMaterial：领用申请审批通过操作失败";
              }
              this.siblingMessage();
              this.systemLog();
            })
            .catch((error) => {
              this.$message({
                message: "操作失败",
                type: "warning",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //审批
    examineNOK() {
      if (this.selectExamineAuxiList.length == 0) {
        this.$message({
          message: "请选择审批单！",
          type: "warning",
        });
        return;
      }
      this.returnExamineShow = true;
    },
    /**
     * 刷新左侧导航栏
     */
    siblingMessage(){
      // TriggerGetMsgNum是事件名字，TriggerGetMsgPara是参数()
      //  也可以没有参数,直接写成siblingCall.$emit("TriggerGetMsgNum");
      siblingCall.$emit("TriggerGetMsgNum","TriggerGetMsgPara");
    },

    //确认审批
    examineResultNOK() {
      if (this.selectExamineAuxiList == 0) {
        this.$message({
          message: "请选择审批记录！",
          type: "warning",
        });
        return;
      }

      if (this.resultMessage == "") {
        this.$message({
          message: "请填写不通过原因！",
          type: "warning",
        });
        return;
      }

      this.$confirm("已选申请单是否全部不通过?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/auxiMaterial/examineResult",
              method: "POST",
              showLoading: true,
              data: this.selectExamineAuxiList,
              params: {
                person: localStorage.getItem("user") || "",
                personNumber: localStorage.getItem("empNumber") || null,
                whCode: localStorage.getItem("whCode") || "",
                result: "20",
                resultMessage: this.resultMessage,
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getExamineAuxi();
				this.returnExamineShow = false;
				this.resultMessage='',
                this.logRemarks = "auxiMaterial：领用申请审批不通过操作成功";
              } else {
                this.$message({
                  message: resp.message,
                  type: "warning",
                });
                this.logRemarks = "auxiMaterial：领用申请审批不通过操作失败";
              }
              this.siblingMessage();
              this.systemLog();
            })
            .catch((error) => {
              this.$message({
                message: "操作失败",
                type: "warning",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //获取我的申请单
    getAuxiPerson() {
      this.$http
        .request({
          url: "/api/auxiMaterial/getAuxiMaterialData",
          method: "GET",
          params: {
            person: localStorage.getItem("user") || "",
            status: "10" || null,
            fcCode: this.fcCode || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.examineData = resp.data.list || [];
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },

    //获取审批单
    getExamineAuxi() {
      this.$http
        .request({
          url: "/api/auxiMaterial/getExamineAuxi",
          method: "GET",
          params: {
            pageNum: this.pageMap.pageNum || "",
            pageSize: this.pageMap.pageSize || "",
            matCode: this.examinpagination.matCode || "",
            fcCode: localStorage.getItem("fcCode") || "",
            samCode: this.examinpagination.samCode || "",
            person: localStorage.getItem("empNumber") || "",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.examineData = resp.data.list || [];
            this.pageMap.total = resp.data.total;
            this.siblingMessage();
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },

    //打印
    prints() {
      if (this.checkList.length == 0) {
        this.$message({
          message: "请选择打印单！",
          type: "warning",
        });
        return;
      }
      this.printList = this.checkList;
      this.printShow = true;
      this.getTime();
    },

    //获取当前时间 格式YYYY-MM-DD
    getTime() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.timeDate = year + seperator1 + month + seperator1 + strDate;
    },

    //全选
    selectAll(val) {
      this.checkList = val;
    },

    //全选
    selectAllExamine(val) {
      this.checkListExamine = val;
    },

    examinResetData() {
      this.examinpagination = {
        samCode: "",
        matCode: "",
      };
	  this.pageMap.pageNum=1;
      this.getExamineAuxi();
    },
    //表单验证
    submitForm(formName) {
      let r = Boolean;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          r = true;
        } else {
          r = false;
        }
      });
      return r;
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //表格导出
    downLoadFileExamine() {
      this.downloadLoadingExamine = true;
      var paramsObj = {
        matCode: this.examinpagination.matCode || "",
        samCode: this.examinpagination.samCode || "",
        person: localStorage.getItem("empNumber") || "",
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/auxiMaterial/getExamineAuxi",
          method: "GET",
          showLoading: true,
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoadExamine(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoadExamine(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function (c) {
          if (c.status == "10") {
            c["status"] = "待审批";
          } else if (c.status == "20") {
            c["status"] = "审批完成";
          } else if (c.status == "30") {
            c["status"] = "待拣配";
          } else if (c.status == "40") {
            c["status"] = "拣配中";
          } else if (c.status == "50") {
            c["status"] = "拣配完成";
          } else if (c.status == "60") {
            c["status"] = "出库完成";
          } else if (c.status == "70") {
            c["status"] = "关闭";
          }

          if (c.checkFlag == "10") {
            c["checkFlag"] = "通过";
          } else if (c.checkFlag == "20") {
            c["checkFlag"] = "不通过";
          }

          if (c.directInventory == true) {
            c["directInventory"] = "是";
          } else if (c.directInventory == false) {
            c["directInventory"] = "否";
          }

          if (c.section != undefined && c.deptName != undefined) {
            c["section"] = c.section + "-" + c.deptName;
          }
        });
        const tHeader = [
          "申请单号",
          "物料编号",
          "物料描述",
          "需求数量",
          "申请人员",
          "部门",
          "状态",
          "申请时间",
          "需求时间",
          "审批部门",
          "申请审批人员",'产品型号','工单数量','寿命','工序'
        ];
        const filterVal = [
          "samCode",
          "matCode",
          "matName",
          "matQuan",
          "person",
          "section",
          "status",
          "createTime",
          "requireDate",
          "examineType",
          "examineWaitPerson",'productModel','orderQuantity','life','ddName'
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "领用审批单",
        });
        this.logContent = "导出";
        this.logRemarks = "stock_auxi_material：导出领用审批记录";
        this.systemLog();
        this.downloadLoadingExamine = false;
      });
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "领用申请",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
  activated() {
	// 从页面跳转传值
    let samCode = this.$route.query.samCode;
    if (samCode) {
      	this.examinpagination.samCode = samCode;
    }
    this.getExamineAuxi();
  },
};
</script>

<style scoped>
.div div {
  width: 170px;
  height: 50px;
  /* border: 1px solid black; */
  margin-left: 10px;
  margin-top: 10px;
  float: left;
  font-weight: 550;
  font-size: 18px;
}

.table table {
  margin-top: 3px;
}

.table table tr td {
  width: 175px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
  color: black;
}

.table table tr th {
  width: 175px;
  height: 50px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
  color: black;
}

.td td {
  font-weight: 800;
  color: black;
}

.color {
  background: rgb(194, 192, 192);
  color: black;
}

.print {
  width: 100%;
  height: 80px;
  /* border: 1px solid red; */
}
</style>